import { useState, useEffect } from 'react'
import AnimatedSpan from 'containers/animatedSpan/AnimatedSpan'
import { useDispatch, useSelector } from 'react-redux'
import { useRequest } from 'hooks/useRequest'
import { setProjects } from 'redux/features/projects/projectsSlice'
import moment from 'moment'
import { setUsers } from 'redux/features/users/usersSlice'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import Spinner from 'components/loader/Spinner'
import DefaultSelect from 'components/formElements/DefaultSelect'

const RateReports = () => {
	const [filterOptions, setFilterOptions] = useState({ isArchive: false, searchString: '', email: null })
	const { projects, users } = useSelector((state) => state)
	const { projectsData } = projects
	const { usersData } = users

	const [getProjects, getProjectsLoading] = useRequest()
	const dispatch = useDispatch()
	const [getUsers] = useRequest()
	useEffect(() => {
        getProjects('/ProjectRates/GetRatesOfProjects', { method: 'GET' }).then((res) => {
            if (res.data.ok) {
                dispatch(
                    setProjects(
                        res.data.result
                    )
                )
            }
        })
			
		getUsers('/Account/GetAllUsers', {
			method: 'GET',
		}).then((res) => {
			if (res.data.ok) {
				dispatch(setUsers(res.data.result))
			}
		})
	}, [filterOptions.isArchive])

	const handleChnage = (e, name, array) => {
		if (name == 'isArchive') {
			setFilterOptions((prev) => ({ ...prev, [name]: e.value }))
		} else if (e == null || e.length == 0 || e.value == '') {
			setFilterOptions((prev) => ({ ...prev, [name]: null }))
		} else {
			if (array) {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e && e != undefined ? e : e.length > 0 && e,
				}))
			} else {
				setFilterOptions((prev) => ({
					...prev,
					[name]: e.value && e.value != undefined ? e.value : e.length > 0 && e[0].value,
				}))
			}
		}

	}
	const filteredProjects = [...projectsData]?.sort((a,b) => {
		if (a.rateEndDate == null) {
			return -1
		}
		if (b.rateEndDate == null) {
			return 1
		}
		return moment(a.rateEndDate, 'DD.MM.YYYY').unix() < moment(b.rateEndDate, 'DD.MM.YYYY').unix() ? -1 : 1
	})?.filter((d) => {
		const keys = Object.keys(filterOptions)
		let rt = [true]
		if (keys.length > 0) {
			keys.forEach((k) => {
				if (filterOptions[k] != null) {
					if (k == 'searchString') {
						const customerPart = d.crmManagementId ? d.crmManagementDisplayName : d.customerName
						let uniName = (d.name + (customerPart || '')).toLowerCase()
						//console.log(uniName, filterOptions[k], "UNINAME");
						rt.push(uniName.match(filterOptions[k].toLowerCase()))
					} else if (k == 'am') {
						rt.push(filterOptions[k].map((e) => e.value).includes(d.accountManager.id))
					} else if (k == 'pm') {
						rt.push(d.projectManager.find((e) => filterOptions[k].map((e) => e.value).includes(e.id)))
					} else if (k == 'isArchive') {
						rt.push(true)
					} else {
						rt.push(d.id == filterOptions[k])
					}
				}
			})
		}
		return rt.every((r) => r)
	})
	return (
		<AnimatedSpan className='page-container d-flex flex-column'>
			{getProjectsLoading ? (
				<div className='d-flex w-100 justify-content-center'>
					<Spinner size={3} />
				</div>
			) : (
				<div className='row'>
					<DataTable
					stripedRows
						className='col-md-12 p-1'
						emptyMessage='Hiç Kayıt Bulunamadı'
						size='small'
						responsiveLayout='stack'
						dataKey='id'
						header={() => (
							<div className='d-flex justify-content-between gap-3'>
								<div className='row flex-1'>
									<div className='col-md-3 pl-0'>
										<span className='p-input-icon-left w-100'>
										<i className="pi pi-search" />
										<input
											type='text'
											placeholder='Proje/Müşteri Adı'
											className='default-input pl-5'
											name='searchString'
											onChange={(e) => handleChnage(e.target, 'searchString')}
										/>
										</span>
									</div>
									<div className='col-md-3'>
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'am' })),
													'am',
													true
												)
											}
											isSearchable
											placeholder='AM'
											isMulti
											selectOptions={usersData.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
									<div className="col-md-3">
										<DefaultSelect
											handleChange={(e) =>
												handleChnage(
													e.map((p) => ({ ...p, name: 'pm' })),
													'pm',
													true
												)
											}
											isSearchable
											placeholder='PM'
											isMulti
											selectOptions={usersData.map((pt) => ({ label: `${pt.firstName} ${pt.lastName}`, value: pt.id }))}
										/>
									</div>
								</div>
							</div>
						)}
						rowClassName={`table-hover `}
						rowExpansionTemplate={() => <div>Expansion</div>}
						value={filteredProjects}
					>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							field='name'
							header='Proje Adı'
							sortable='true'
							body={(rowData) => {
                                const rateEnd = moment(rowData.rateEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                                const today = moment(new Date(), 'YYYY-MM-DD')
                                const isNear = rateEnd && moment(rateEnd).diff( today, 'days') <= 30
                                const isPassed = rateEnd && moment(rateEnd).diff( today, 'days') < 0
								return (
									<div className={`text-sm cellSetTransparent ${(!rowData.rateEndDate || isPassed) ? 'bg-danger-dark' : isNear ? "bg-warning" : "cellSetTransparent"}`}>
										{(rowData.crmManagementId ? rowData.crmManagementDisplayName : rowData.customerName) && `${(rowData.crmManagementId ? rowData.crmManagementDisplayName : rowData.customerName)} - `}{rowData.name}
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							field='accountManager.name'
							header='AM'
							sortable='true'
							body={(rowData) => {
                                const rateEnd = moment(rowData.rateEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                                const today = moment(new Date(), 'YYYY-MM-DD')
                                const isNear = rateEnd && moment(rateEnd).diff( today, 'days') <= 30
                                const isPassed = rateEnd && moment(rateEnd).diff( today, 'days') < 0
								return (
									<div className={`text-sm cellSetTransparent ${(!rowData.rateEndDate || isPassed) ? 'bg-danger-dark' : isNear ? "bg-warning" : "cellSetTransparent"}`}>
										{rowData?.accountManager?.name && rowData.accountManager.name} 
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							style={{ width: 'auto', position: 'relative' }}
							field='projectManager'
							header='PM'
							sortable='true'
							body={(rowData) => {
                                const rateEnd = moment(rowData.rateEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                                const today = moment(new Date(), 'YYYY-MM-DD')
                                const isNear = rateEnd && moment(rateEnd).diff( today, 'days') <= 30
                                const isPassed = rateEnd && moment(rateEnd).diff( today, 'days') < 0
								return (
									<div className={`text-sm cellSetTransparent ${(!rowData.rateEndDate || isPassed) ? 'bg-danger-dark' : isNear ? "bg-warning" : "cellSetTransparent"}`}>
										{rowData?.projectManager?.length > 0 && rowData.projectManager.map(p => p.name).join(',')} 
									</div>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm'
							field='live'
							header='Rate Bitiş Tarihi'
							sortable='true'
							style={{ width: 'auto' }}
							body={(rowData) => {
                                const rateEnd = moment(rowData.rateEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                                const today = moment(new Date(), 'YYYY-MM-DD')
                                const isNear = rateEnd && moment(rateEnd).diff( today, 'days') <= 30
                                const isPassed = rateEnd && moment(rateEnd).diff( today, 'days') < 0
								return (
									<span className={`projects-list-card-footer-period cellSetTransparent text-sm ${(!rowData.rateEndDate || isPassed) ? 'bg-danger-dark' : isNear ? "bg-warning" : "cellSetTransparent"}`}>
										{rowData.rateEndDate && <span> {rowData.rateEndDate}</span>}
									</span>
								)
							}}
						/>
						<Column
							headerClassName='text-bold bg-primary text-default'
							className='text-semi-bold text-sm relative-cell'
							field='Rate'
							header='Rate Tutarı'
							style={{ width: '10rem' }}
							body={(rowData) => {
                                const rateEnd = moment(rowData.rateEndDate, 'DD.MM.YYYY').format('YYYY-MM-DD')
                                const today = moment(new Date(), 'YYYY-MM-DD')
                                const isNear = rateEnd && moment(rateEnd).diff( today, 'days') <= 30
                                const isPassed = rateEnd && moment(rateEnd).diff( today, 'days') < 0
								return (
									<span className={`text-sm cellSetTransparent ${(!rowData.rateEndDate || isPassed) ? 'bg-danger-dark' : isNear ? "bg-warning" : "cellSetTransparent"}`}>
										{rowData.rate} {rowData.rate && rowData.rateCurrency}
									</span>
								)
							}}
						/>
					</DataTable>
				</div>
			)}
		</AnimatedSpan>
	)
}
export default RateReports
